import { render, staticRenderFns } from "./PointAnalysisReport.vue?vue&type=template&id=ef834a06&scoped=true"
import script from "./PointAnalysisReport.vue?vue&type=script&lang=ts"
export * from "./PointAnalysisReport.vue?vue&type=script&lang=ts"
import style0 from "./PointAnalysisReport.vue?vue&type=style&index=0&id=ef834a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef834a06",
  null
  
)

export default component.exports